// extracted by mini-css-extract-plugin
module.exports = {"name":"ItemMenu_name__2NlPo","value":"ItemMenu_value__2GhGB","profile":"ItemMenu_profile__1TZL-","right":"ItemMenu_right__3ckbi"};